import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import ApiGo from '../../../actions/ApiGo';
import ApiGo_TS from '../../../actions/ApiGo_TS';

const AddLineGroup =(props)=>{
    const {t} = useTranslation()
    const POST_OR_PUT = props.result[4]
    const [role, setRole] = useState(props.result[0]);
    const [mustCompelete, setMustCompelete] = useState(false);
    const [token, setToken] = useState(props.result[3]);
    const [title, setTitle] = useState(props.result[2]);
    const lineGroupID = props.result[5];
    const [userArr, setUserArr] = useState([]);
    const [user, setUser] = useState(props.result[1]);
    function postLineNotify(){
        let userid = user
        if(!user) {userid=1}

        if(token===""){setMustCompelete(true)}
        else{
            if(POST_OR_PUT==="POST"){
                ApiGo_TS.postline_notify_post(userid, token, title)
                .then(()=>{props.setRefresh(true)})
                .catch(err=>{console.log(err);})
            }
            else if(POST_OR_PUT==="PUT"){
                ApiGo_TS.putline_notify_group_title(userid, lineGroupID, token, title)
                .then(()=>{props.setRefresh(true)})
                .catch(err=>{console.log(err);})
            }
            ApiGo_TS.getLineNotify_start()
            .then(res=>{console.log(res);})
            .catch(err=>{console.log(err);})
            props.hide()
        }
    }
    useEffect(() => {
        ApiGo.getUsers()
        .then(res=>{setUserArr(res.users)})
        .catch(err=>{console.log(err);})
    }, []);
    return(
        <div className="pos-f z-1 wid-full hig-full top-0 left-0 fx-ccc bg-black" onClick={props.hide}>
            <div className="layout-history fx-d-c pad-30 l r" onClick={e=>e.stopPropagation()}>
                <div className="h-100 fx-d-c w-100 font-ml pad-31">
                    <div className='font-xl fx-fsc h-15'>Line Notify {t("ADMIN.OTHER_PAGE.GROUP_REGISTRATION")}</div>
                    <div className='fx-d-c margt-xs h-20'>
                        {/* <div className='fx-d-c w-40'>
                            <div className='fx-d-r'>
                                {t("ADMIN.OTHER_PAGE.SENT_THROUGH_ROLE")}
                                {mustCompelete[0]?<div className='font-red margl-xs'>*必填</div>:null}
                            </div>
                            <select value={role} onChange={e=>{setRole(e.target.value)}}>
                                <option value="superdoctor" key="superdoctor">superdoctor</option>
                                <option value="doctor" key="doctor">doctor</option>
                            </select>
                        </div> */}
                        <div className='fx-d-c w-40 margt-xs'>
                            {t("ADMIN.OTHER_PAGE.SENT_THROUGH_USER")}
                            <select value={user} onChange={e=>{setUser(e.target.value)}}>
                                {userArr.map(user=>{
                                    return <option value={user.id} key={user.email}>{user.email}</option>
                                })}
                            </select>
                         </div>
                    </div>
                    <div className='fx-d-c margt-xs h-20'>
                        <div className='fx-d-r'>
                            {t("ADMIN.OTHER_PAGE.INPUT_TOKEN")}
                            {mustCompelete?<div className='font-red margl-xs'>*必填</div>:null}
                        </div>
                        <input className='border' value={token} onChange={e=>{setToken(e.target.value)}} />
                    </div>
                    <div className='fx-d-c margt-xs h-40'>
                        {t("ADMIN.OTHER_PAGE.INPUT_DISCRITION")}
                        <textarea className='border' rows="4" cols="50" value={title} onChange={e=>{setTitle(e.target.value)}}></textarea>
                    </div>

                    <div className='fx-d-r w-100 fx-fec margt-s'>
                        <div className='bgC-alert-EE br-10 font-l pad-15 l r shadow-xs margr-s' onClick={postLineNotify}>{t("GLOBAL.CONFIRM")}</div>
                        <div className='bgC-alert-E br-10 font-l  pad-15 l r shadow-xs' onClick={props.hide}>{t("GLOBAL.CANCEL")}</div>
                    </div>
                </div>
            </div>
        </div>
    );

}
export default AddLineGroup;